import { gql } from '@apollo/client';

/**
 * GraphQL query to fetch all standard labels
 * Consolidated from content-search and system-config/label-management domains
 *
 * @see packages/bff/src/schema.gql - StandardLabelsResponse type (lines 1291-1293)
 */
export const GET_STANDARD_LABELS = gql`
  query GetStandardLabels {
    standardLabels {
      labels {
        id
        labelName
        labelShortName
        policy
        contentType
        scope {
          global
          communityGroups
          communities
        }
        labelStatus
        labelNumMap
        createdBy
        createdAt
        lastModifiedBy
        lastModifiedAt
        backupVersions
        maxSeverity
      }
    }
  }
`;
